import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const footerLinks = [
    { label: t('footer.links.about'), href: '/about' },
    { label: t('footer.links.contact'), href: '/about#contact' },
    { label: t('footer.links.privacy'), href: '#' },
    { label: t('footer.links.terms'), href: '#' },
    { label: t('footer.links.creators'), href: '#' },
    { label: t('footer.links.help'), href: '#' },
  ];

  const socialLinks = [
    { label: t('footer.social.weibo'), icon: 'ri-weibo-line', href: '#' },
    { label: t('footer.social.wechat'), icon: 'ri-wechat-line', href: '#' },
    { label: t('footer.social.bilibili'), icon: 'ri-bilibili-line', href: '#' },
    { label: t('footer.social.douyin'), icon: 'ri-tiktok-line', href: '#' },
  ];

  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {/* Brand Column */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-bold font-heading text-background-50">
                {t('siteName')}
              </span>
            </Link>
            <p className="text-sm text-secondary-200 leading-relaxed max-w-xs">
              {t('footer.description')}
            </p>
          </div>

          {/* Links Column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-secondary-200 mb-4">
              导航链接
            </h4>
            <ul className="space-y-2">
              {footerLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-100 hover:text-background-50 transition-colors whitespace-nowrap"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Social Column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-secondary-200 mb-4">
              关注我们
            </h4>
            <ul className="space-y-2">
              {socialLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-sm text-background-100 hover:text-background-50 transition-colors flex items-center gap-2 whitespace-nowrap"
                    rel="nofollow"
                  >
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={link.icon} />
                    </span>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-secondary-200 mb-4">
              订阅更新
            </h4>
            <p className="text-sm text-secondary-200 mb-3">
              获取最新精选视频推荐
            </p>
            <form
              onSubmit={(event) => event.preventDefault()}
              className="flex gap-2"
              id="newsletter-form"
            >
              <input
                type="email"
                name="email"
                placeholder="输入邮箱"
                required
                className="flex-1 bg-transparent border-b border-secondary-400 text-sm py-2 px-0 text-background-50 placeholder:text-secondary-400 focus:outline-none focus:border-background-50"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-full hover:bg-primary-600 transition-colors"
                aria-label="订阅"
              >
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-background-50" />
                </span>
              </button>
            </form>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-secondary-700/50 px-4 md:px-8 py-6">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-secondary-300 whitespace-nowrap">
            {t('footer.copyright')} &copy; {new Date().getFullYear()}
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/about"
              className="text-xs text-secondary-300 hover:text-background-100 transition-colors whitespace-nowrap"
            >
              {t('footer.links.about')}
            </Link>
            <Link
              to="#"
              className="text-xs text-secondary-300 hover:text-background-100 transition-colors whitespace-nowrap"
            >
              {t('footer.links.privacy')}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
